import styles from './FormButtonV2.module.scss'
import Loader from './Loader'
import React from 'react'

export const FormButtonV2 = ({
  countSalesStatus,
  countSalesLink,
  bindingProduct,
  isLoading,
  limitSalesStatus,
  handleSubmit,
  setCheckboxesError,
  accept_license,
  accept_oferta,
  btnDisabled
}) => {
  const handleClick = (e) => {
    e.preventDefault()
    if (!accept_license && !accept_oferta) {
      setCheckboxesError({ accept_license: true, accept_oferta: true })
    } else if (!accept_license) {
      setCheckboxesError((prev) => ({ ...prev, accept_license: true }))
    } else if (!accept_oferta) {
      setCheckboxesError((prev) => ({ ...prev, accept_oferta: true }))
    } else {
      handleSubmit(e)
    }
  }

  return countSalesStatus ? (
    limitSalesStatus ? (
      <button
        data-testid="loader-button"
        type="button"
        className={styles.button}
        disabled
      >
        <Loader />
      </button>
    ) : (
      <button
        data-testid="continue-shopping-button"
        type="button"
        className={styles.button}
        onClick={() =>
          countSalesLink ? window.open(countSalesLink, '_self') : history.back()
        }
      >
        Продолжить покупки
      </button>
    )
  ) : (
    <button
      data-testid="submit-button"
      type="button"
      disabled={btnDisabled}
      className={styles.button}
      onClick={(e) => handleClick(e)}
    >
      {isLoading ? (
        <Loader />
      ) : !bindingProduct ? (
        'Перейти к оплате'
      ) : (
        'Привязать банковскую карту'
      )}
    </button>
  )
}
